export const getConversionPromptKnownError = (state) => state.ConversionPromptReducer.knownError;
export const getConversionPromptActiveModal = (state) => state.ConversionPromptReducer.activeModal;
export const getConversionPromptActiveModalId = (state) => state.ConversionPromptReducer.activeModal?.id;
export const getConversionPromptActiveWatchState = (state) => state.ConversionPromptReducer.activeWatchState;
export const getConversionPromptSessionStarted = (state) => state.ConversionPromptReducer.isSessionStarted;
export const getConversionPromptLoadingState = (state) => state.ConversionPromptReducer.loadingState;
export const getSessionAdvanceData = (state) => state.SessionData.advanceData;
export const getSessionData = (state) => state.SessionData.data;
